<template>
  <div :class="isPC ? 'page-wrapper' : 'm-page-wrapper'">
    <div :class="[isPC ? 'header-part' : 'm-header-part', { 'star-header-part': isStar }]">
      <img src="../assets/web/main_title2026.png" alt="" class="main-title" v-if="isPC">
      <img src="../assets/m/main_title2026.png" alt="" class="main-title m-main-title" v-else>
      <div v-if="isPC" :class="['button-group']">
        <!-- <div class="tab-item">
          <p class="tab-left">平面展 2D Exhibition</p>
          <span class="button-left" @click="goToWeb('cn')">中文</span>
          <span class="button-left" @click="goToWeb('en')">English</span>
        </div> -->
        <div class="tab-item">
          <p class="tab-right">虚拟展 Virtual Exhibition</p>
          <span class="button-left" @click="goTo2026()">Go 2026</span>
          <span class="button-right" @click="goToVR('cn')">往届虚拟展</span>
          <span class="button-right" @click="goToVR('en')">Previous Virtual Pavilions</span>
        </div>
      </div>
      <div v-else class="m-button-group">
        <!-- <div class="m-tab-item">
          <p class="m-tab-left">平面展 2D Exhibition</p>
          <span class="button-left" @click="goToWeb('cn', 'showMenu')">中文</span>
          <span class="button-left" @click="goToWeb('en', 'showMenu')">English</span>
        </div> -->
        <div class="m-tab-item">
          <p class="m-tab-right">虚拟展 Virtual Exhibition</p>
          <span class="button-left" @click="goTo2026()">Go 2026</span>
          <span class="button-right" @click="goToVR('cn')">往届虚拟展</span>
          <span class="button-right" @click="goToVR('en')">Previous Virtual Pavilions</span>
        </div>
      </div>
      <!-- <div class="info-area">
        <p class="cn-font">中国<span class="dot-item"></span>上海</p>
        <p>SHANGHAI<span class="dot-item"></span>CHINA</p>
        <p class="cn-font">2024年8月2日 - 6日</p>
        <p>August 2-6, 2024</p>
      </div> -->
      <!-- <div v-if="isPC" class="footer-area">
        <WebFooter />
      </div> -->

      <div class="main-partner" v-if="isPC">
        <img src="../assets/web/main_partner2026.png" alt="" />
        <p>技术支持单位: 上海市教育软件发展有限公司</p>
      </div>
      <div v-else class="main-partner m-main-partner">
        <img src="../assets/m/main_partner2026.png" alt="" />
        <p>技术支持单位 <br />上海市教育软件发展有限公司</p>
      </div>

    </div>
    <!-- <WebFooter v-if="!isPC" /> -->
  </div>
</template>

<script>
// import WebFooter from '@/common/WebFooter'
export default {
  name: 'MainPage',
  // components: { WebFooter },
  data() {
    return {
      isStar: false
    }
  },
  watch: {
    '$route': function (routerTo) {
      if (routerTo.path.indexOf('/web/starlight') > -1) {
        this.isStar = true;
      } else {
        this.isStar = false;
      }
    }
  },
  created() {
    if (this.$route.path.indexOf('/web/starlight') > -1) {
      this.isStar = true;
    } else {
      this.isStar = false;
    }
  },
  methods: {
    goToWeb(lang, showMenu) {
      if (lang !== this.currentLang) {
        this.changeLang(lang)
      }
      if (showMenu) {
        this.$router.push({ name: 'menter' })
      } else {
        this.$router.push({ name: 'web' })
      }
    },
    goToVR(lang) {
      if (lang !== this.currentLang) {
        this.changeLang(lang)
      }
      window.open('./app.html#/kr_view', '_blank')
    },
    goTo2026() {
      window.open('https://siyste2024.secsa.cn/2026qbh/', '_blank')
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.header-part {
  width: 100%;
  height: 100vh;
  background-image: url("../assets/web/main_bg2026.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header-part.star-header-part {
  background-image: url("../assets/web/top_header_bg1.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.header-part h1,
.m-header-part h1 {
  font-size: 4rem;
  color: #0088d3;
  text-align: center;
  font-weight: bolder;
}

.header-part h4,
.m-header-part h4 {
  font-size: 2.4rem;
  color: #0088d3;
  text-align: center;
}

.main-title {
  display: block;
  margin: 0 auto;
  padding-top: 3vh;
  width: min(850px, 80vw);
  flex-shrink: 0;
}

.m-main-title {
  width: calc(100% - 3rem);
  padding-top: 12vh;
}

.main-partner {
  display: block;
  margin: 0 auto;
  padding-bottom: 3vh;
  width: min(600px, 65vw);
  flex-shrink: 0;
}

.main-partner img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.main-partner p {
  font-size: 14px;
  color: #d3d3d3;
  text-align: center;
  font-weight: 550;
  margin-top: 10px;
}

.m-main-partner {
  width: 50vw;
  padding-top: 12vh;
  padding-bottom: 0;
}

.button-group {
  text-align: center;
  flex-shrink: 0;
}

.tab-item {
  display: inline-block;
  font-size: 1.8rem;
  font-weight: 550;
}

.tab-item p {
  padding: 10px 20px 6px;
  min-width: 180px;
  font-size: 2.4rem;
}

.tab-item span {
  margin-left: 5px;
  margin-right: 5px;
  font-size: 2rem;
  height: 4rem;
  /* width: 8rem; */
  line-height: 4rem;
  padding-left: 1.4rem;
  padding-right: 1.4rem;
  border-radius: 2rem;
  display: inline-block;
  cursor: pointer;
}

.tab-left {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}

.tab-right {
  color: #eae82d;
  border-bottom: 2px solid #eae82d;
}

.button-left {
  border: 1px solid #ffffff;
  color: #ffffff;
  background-color: #ea6c2d;
}

.button-left:hover {
  background-color: #ffffff;
  color: #0088d3;
}

.button-right {
  border: 1px solid #ffffff;
  color: #ffffff;
}

.button-right:hover {
  background-color: #ffffff;
  color: #0088d3;
}

.info-area {
  text-align: center;
  color: #ffffff;
  margin-top: 4rem;
  font-size: 20px;
  font-weight: 550;
}

.info-area p {
  margin-top: 0px;
  margin-bottom: 10px;
  line-height: 1;
}

.cn-font {
  letter-spacing: 2px;
}

.dot-item {
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border-radius: 50%;
  background-color: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
}

.footer-area {
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
}

/* 移动端 */
.m-page-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.m-header-part {
  width: 100%;
  background-image: url("../assets/m/main_bg2026.png");
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.m-button-group {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  padding-top: 6vh;
}

.m-tab-item {
  width: 100%;
  display: inline-block;
}

.m-tab-item span {
  font-size: 15px;
  height: 30px;
  width: 90px;
  line-height: 30px;
  border-radius: 15px;
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
  cursor: pointer;
}

.m-tab-item p {
  padding: 10px 20px 6px;
  margin-bottom: 15px;
}

.m-tab-left {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}

.m-tab-item .button-left {
  width: 40%;
  color: #ffffff;
}

.m-tab-item .button-left:hover {
  background-color: inherit;
  color: #ffffff;
}

.m-tab-item .button-right:hover {
  background-color: inherit;
  color: #ffffff;
}

.m-tab-right {
  color: #eae82d;
  border-bottom: 2px solid #eae82d;
}

.m-tab-item .button-right {
  width: 40%;
  color: #ffffff;
}

.m-header-part .info-area {
  margin-top: 20px;
  font-size: 16px;
}

.m-header-part .info-area p {
  margin-bottom: 6px;
}

@media screen and (max-width: 900px) {}
</style>
